<template>
    <div>
        <template v-if="!ClientContractID || !ClientContractID.id">
            <div class="d-flex align-items-center justify-content-center" style="height: calc(100vh - 57px);">
                <h2 class="text-danger">Please choose a contract to load the report.</h2>
            </div>
        </template>
        <div v-else class="pt-15 animated fadeIn equipmentList bgV2">
            <div class="boxShadow setBorderRadius heig-frame-equipment-group">
                <b-row no-gutters>
                    <b-col md="12" class="heig-frame-child">
                        <gofix-card class="pt-20">
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        vLabel="name"
                                        label="Town Council"
                                        required
                                        show-icon-required
                                        :filterable="false"
                                        :options="options.town_councils"
                                        v-model="filters.town_council"
                                        @search="searchTownCouncil"
                                        @change="onTownCouncilChange">
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span
                                                v-b-tooltip.hover.top
                                                :title="option.name"
                                                v-html="$options.filters.highlightNode(option.name, key_search_division)"
                                            ></span>
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        vLabel="name"
                                        label="Division"
                                        :filterable="false"
                                        :class="{ 'run-loading small-loading': loading.division }"
                                        :options="options.divisions"
                                        v-model="filters.division"
                                        :disabled="!filters.town_council"
                                        @search="searchDivision"
                                        @change="onDivisionChange">
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span
                                                v-b-tooltip.hover.top
                                                :title="option.name"
                                                v-html="$options.filters.highlightNode(option.name, key_search_division)"
                                            ></span>
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        vLabel="name"
                                        label="Block"
                                        :filterable="false"
                                        :class="{ 'run-loading small-loading': loading.block }"
                                        :options="options.blocks"
                                        v-model="filters.block"
                                        :disabled="!filters.division"
                                        @search="searchBlocks"
                                        @change="onBlockChange">
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span
                                                v-b-tooltip.hover.top
                                                :title="option.name"
                                                v-html="$options.filters.highlightNode(option.name, key_search_division)"
                                            ></span>
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                                
                            </b-row>
                            <b-row class="mt-2">
                                <b-col md="4">
                                    <gofix-form-dropdown 
                                        label="Lift No."
                                        :clearable="true"
                                        :class="{ 'run-loading small-loading': loading.lift_no }"
                                        :disabled="!filters.block"
                                        :options="options.lift_nos"
                                        v-model="filters.lift_no">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        vLabel="contract_title"
                                        label="Supplier Contract"
                                        :filterable="false"
                                        :class="{ 'run-loading small-loading': loading.supplier_contract }"
                                        :options="options.supplier_contracts"
                                        v-model="filters.supplier_contract"
                                        @search="searchSupplierContract">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Status"
                                        :filterable="false"
                                        :clearable="true"
                                        :options="job_status_options"
                                        vLabel="text"
                                        :reduce="option => option.value"
                                        v-model="filters.job_status">
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col md="4">
                                    <gofix-form-input-date
                                        label="Schedule Date (From)"
                                        required
                                        show-icon-required
                                        v-model="filters.schedule_date_from">
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input-date
                                        label="Schedule Date (To)"
                                        required
                                        show-icon-required
                                        v-model="filters.schedule_date_to">
                                    </gofix-form-input-date>
                                </b-col>
                                
                                <b-col md="12" class="d-flex align-items-center pb-2">
                                    <gofix-button
                                        class="mx-1"
                                        label="List"
                                        :loading="loading.list"
                                        @click="onList">
                                    </gofix-button>
                                    <gofix-button
                                        class="mx-1 min-width-90"
                                        outline
                                        label=""
                                        :loading="loading.excel"
                                        :disabled="!canExport"
                                        @click="downloadExcel">
                                        <template slot="gofix:button:afterLabel">
                                            <i class="icon-cloud-download icons font-size-16"></i>
                                        </template>
                                    </gofix-button>
                                    <gofix-button
                                        class="mx-1 min-width-90"
                                        outline
                                        label=""
                                        :loading="loading.pdf"
                                        :disabled="!canExport"
                                        @click="downloadPdf">
                                        <template slot="gofix:button:afterLabel">
                                            <i class="icon-printer icons font-size-16"></i>
                                        </template>
                                    </gofix-button>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card class="mb-0 heig-frame-child" fullContent>
                            <div v-if="loading.list" class="text-center py-5">Loading report...</div>
                            <div v-else-if="!reportData" class="text-center py-5 text-muted">
                                Select filters and click List to view the checklist report.
                            </div>
                            <template v-else>
                                <div v-if="reportData.total_jobs === 0" class="text-center py-5 text-danger">
                                    No jobs found
                                </div>
                                <template v-else>
                                    <JobGoFMReportGrid
                                        ref="reportGrid"
                                        :report-data="reportData"
                                    />
                                </template>
                            </template>
                        </gofix-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import JobGoFMReportGrid from './JobGoFMReportGrid.vue';
import { is } from 'core-js/core/object';
import { isBuffer } from 'lodash';

export default {
    name: 'job-list-gofm-report',
    components: {
        JobGoFMReportGrid,
    },
    data() {
        return {
            hasSearched: false,
            reportData: null,
            filters: {
                town_council: null,
                division: null,
                supplier_contract: null,
                schedule_date_from: null,
                schedule_date_to: null,
                job_status: null,
                block: null,
                lift_no: null,
            },
            options: {
                town_councils: [],
                divisions: [],
                supplier_contracts: [],
                blocks: [],
                lift_nos: ['A', 'B', 'C', 'D', 'E', 'F'],
            },
            job_status_options: [
                { value: 'Planned', text: 'Planned' },
                { value: 'Due', text: 'Due' },
                { value: 'Started', text: 'Started' },
                { value: 'Completed', text: 'Completed' },
                { value: 'Verified', text: 'Verified' },
                { value: 'Expired', text: 'Expired' },
            ],
            loading: {
                list: false,
                excel: false,
                pdf: false,
                division: false,
                supplier_contract: false,
                block: false,
                lift_no: false,
            },
            timer: {
                town_council: null,
                division: null,
                supplier_contract: null,
                block: null,
            },
            key_search_division: '',
            key_search_block: '',
        };
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
        }),
        canExport() {
            return this.hasSearched && this.reportData && this.reportData.blocks && this.reportData.blocks.length;
        }
    },
    filters: {
        highlightNode(val, option_selected) {
            if (!val) return val;
            if (option_selected) {
                if (option_selected.name) {
                    val = val.replace(
                        option_selected.name,
                        `<span class="d-inline font-weight-bold">${option_selected.name}</span>`
                    );
                } else if (typeof option_selected === 'string') {
                    const regex = new RegExp(option_selected, 'i');
                    const index = val.search(regex);
                    const substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }
            return val;
        },
    },
    created() {
        this.getTownCouncils();
        if (this.ClientContractID && this.ClientContractID.id) {
            this.getTownCouncils();
            this.getSupplierContracts(null, true);
        }
    },
    watch: {
        ClientContractID(val) {
            if (val && val.id) {
                this.getTownCouncils();
                this.getSupplierContracts(null, true);
                this.filters.town_council = this.filters.division = this.filters.supplier_contract = this.filters.block = this.filters.lift_no = null
            }
        },
    },
    methods: {
        onList() {
            if(!this.filters.town_council) {
                return this.$alertNotification('Town Council is required', 'danger');
            }
            if(!this.filters.schedule_date_from) {
                return this.$alertNotification('Schedule Date (From) is required', 'danger');   
            }
            if(!this.filters.schedule_date_to) {
                return this.$alertNotification('Schedule Date (To) is required', 'danger');
            }
            
            if (
                this.filters.schedule_date_from &&
                this.filters.schedule_date_to &&
                moment(this.filters.schedule_date_from).isAfter(this.filters.schedule_date_to)
            ) {
                return this.$alertNotification('Schedule Date (From) must be before Schedule Date (To)', 'danger');
            }

            if (this.filters.schedule_date_from && this.filters.schedule_date_to) {
                const start = moment(this.filters.schedule_date_from).startOf('day');
                const end = moment(this.filters.schedule_date_to).startOf('day');
                const maxEnd = start.clone().add(1, 'month');
                if (end.isAfter(maxEnd)) {
                    return this.$alertNotification('Schedule Date range must not exceed 1 month', 'danger');
                }
            }
            this.loadReportList();
        },
        async loadReportList() {
            this.loading.list = true;
            this.reportData = null;

            const request = Object.assign({}, this.getExportRequest(), { format: 'list' });

            await this.$store
                .dispatch('JobController/exportGoFMReport', request)
                .then((data) => {
                    const report = data && data.data ? data.data : data;
                    this.reportData = report;
                    this.hasSearched = true;
                    if (!report || !report.blocks || !report.blocks.length) {
                        this.$alertNotification('No report data found', 'warning');
                    }
                })
                .catch(() => {
                    this.hasSearched = false;
                    this.$alertNotification('Can not load the report', 'danger');
                })
                .finally(() => {
                    this.loading.list = false;
                });
        },
        buildFilter() {
            const filter = {
                module_type: 'GOFM SVC',
            };

            if (this.ClientContractID && this.ClientContractID.id) {
                filter.client_contract_id = this.ClientContractID.id;
            }

            if (this.filters.town_council && this.filters.town_council.id) {
                filter.location_id = this.filters.town_council.id;
            }

            if (this.filters.division && this.filters.division.id) {
                filter.location_id = this.filters.division.id;
            }

            if (this.filters.block && this.filters.block.id) {
                filter.location_id = this.filters.block.id;
            }

            if (this.filters.supplier_contract && this.filters.supplier_contract.id) {
                filter.supplier_contract_id = this.filters.supplier_contract.id;
            }
            if (this.filters.job_status) {
                filter.job_status = [this.filters.job_status];
            }

            if (this.filters.schedule_date_from) {
                filter.schedule_date_from = moment(this.filters.schedule_date_from).format('YYYY-MM-DD');
            }

            if (this.filters.schedule_date_to) {
                filter.schedule_date_to = moment(this.filters.schedule_date_to).format('YYYY-MM-DD');
            }

            if (this.filters.lift_no) {
                filter.lift_no = this.filters.lift_no;
            }

            return filter;
        },
        getExportRequest() {
            return {
                filter: this.buildFilter(),
                page: 1,
                limit: -1,
                sortColumn: 'planned_date',
                sortDirection: 'desc',
                useDatabaseView: true,
            };
        },
        downloadFile(response, defaultName) {
            let nameFile = defaultName;
            if (response.headers['content-disposition']) {
                const arrTemp = response.headers['content-disposition'].split('filename=');
                if (arrTemp[1]) {
                    nameFile = arrTemp[1].replaceAll('"', '');
                }
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nameFile);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        async downloadExcel() {
            if (!this.canExport) {
                return this.$alertNotification('Please click List to load data before export', 'warning');
            }
            this.loading.excel = true;
            const exportRequest = Object.assign({}, this.getExportRequest(), { format: 'excel' });
            const defaultName = `Checklist-Report-${moment().format('DD-MMM-YYYY')}.xls`;

            try {
                const response = await this.$store.dispatch('JobController/exportGoFMReport', exportRequest);
                if (response && response.data && response.data.size > 0) {
                    this.downloadFile(response, defaultName);
                    return;
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.loading.excel = false;
            }
        },
        async downloadPdf() {
            if (!this.canExport) {
                return this.$alertNotification('Please click List to load data before export', 'warning');
            }
            if (!this.$refs.reportGrid) {
                return this.$alertNotification('Report grid is not ready', 'warning');
            }

            this.loading.pdf = true;
            const defaultName = `Checklist-Report-${moment().format('DD-MMM-YYYY')}.pdf`;

            /*try {
                await this.$refs.reportGrid.exportPdf(defaultName);
            } catch (err) {
                console.log(err);
                this.$alertNotification('Failed to export PDF', 'danger');
            } finally {
                this.loading.pdf = false;
            }*/

            try {
                 const exportRequest = Object.assign({}, this.getExportRequest(), { format: 'pdf' });
                const response = await this.$store.dispatch('JobController/exportGoFMReport', exportRequest);
                if (response && response.data && response.data.size > 0) {
                    this.downloadFile(response, defaultName);
                    return;
                }
                if (response && response.data && response.data.size === 0) {
                    this.$alertNotification('Blank report', 'warning');
                    return;
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.loading.pdf = false;
            }
        },
        async getTownCouncils(search) {
            await this.$store.dispatch('PropertyController/getSearchProperties', {
                keyword: search,
                property_root_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.property_root_id : null,
                parent_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.property_root_id : null,
                limit: 100,
                contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                // is_active: true
            })
            .then((response) => {
                this.options.town_councils = response;
            })
            .catch(() => {});
        },
        searchTownCouncil(search, loading) {
            this.options.town_councils = [];
            loading(true);
            if (this.timer.town_council) {
                clearTimeout(this.timer.town_council);
                this.timer.town_council = null;
            }
            this.timer.town_council = setTimeout(async () => {
                try {
                    await this.getTownCouncils(search);
                    loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        onTownCouncilChange(val, isInit = false) {
            this.filters.division = null;
            this.filters.supplier_contract = null;
            this.options.divisions = [];
            // this.options.supplier_contracts = [];
            if (val && val.id) {
                this.searchDivision('', () => {});
                this.searchBlocks('', () => {});
            }
            if (!isInit) {
                this.hasSearched = false;
                this.reportData = null;
            }
        },
        searchDivision(search, loading) {
            if (!this.filters.town_council || !this.filters.town_council.id) {
                if (typeof loading === 'function') loading(false);
                return;
            }
            this.options.divisions = [];
            if (typeof loading === 'function') loading(true);
            this.loading.division = true;
            if (this.timer.division) {
                clearTimeout(this.timer.division);
                this.timer.division = null;
            }
            this.timer.division = setTimeout(() => {
                this.key_search_division = search;
                this.$store
                    .dispatch('PropertyController/getSearchProperties', {
                        keyword: search,
                        property_root_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.property_root_id : null,
                        parent_id: this.filters.town_council.id,
                        limit: 100,
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                    })
                    .then((response) => {
                        this.options.divisions = response;
                    })
                    .finally(() => {
                        this.loading.division = false;
                        if (typeof loading === 'function') loading(false);
                    });
            }, 500);
        },
        searchBlocks(search, loading) {
            if (!this.filters.division || !this.filters.division.id) {
                if (typeof loading === 'function') loading(false);
                return;
            }
            this.options.blocks = [];
            if (typeof loading === 'function') loading(true);
            this.loading.block = true;
            if (this.timer.block) {
                clearTimeout(this.timer.block);
                this.timer.block = null;
            }
            this.timer.block = setTimeout(() => {
                this.key_search_block = search;
                this.$store
                    .dispatch('PropertyController/getSearchProperties', {
                        keyword: search,
                        property_root_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.property_root_id : null,
                        parent_id: this.filters.division.id,
                        limit: 100,
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                    })
                    .then((response) => {
                        this.options.blocks = response;
                    })
                    .finally(() => {
                        this.loading.block = false;
                        if (typeof loading === 'function') loading(false);
                    });
            }, 500);
        },
        async getSupplierContracts(search = null, resetSelection = true) {
            this.loading.supplier_contract = true;
            const tableRequest = {
                filter: {
                    contract_title: { type: 'text', value: search, function: 'ilike', with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: 'contract_title',
                sortDirection: 'ASC',
            };

            await this.$store
                .dispatch('ContractController/getListSContracts', tableRequest)
                .then((response) => {
                    this.options.supplier_contracts = response.data.data.contracts;
                    if (resetSelection) {
                        this.filters.supplier_contract = null;
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.loading.supplier_contract = false;
                });
        },
        searchSupplierContract(search, loading) {
            loading(true);
            this.options.supplier_contracts = [];
            if (this.timer.supplier_contract) {
                clearTimeout(this.timer.supplier_contract);
                this.timer.supplier_contract = null;
            }
            this.timer.supplier_contract = setTimeout(async () => {
                try {
                    await this.getSupplierContracts(search, false);
                    loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        onDivisionChange(val) {
            this.options.blocks = [];
            this.filters.block = null;
            if (val && val.id) {
                this.searchDivision('', () => {});
                this.searchBlocks('', () => {});
            }
        },
        onBlockChange(val) {
            this.options.lift_nos = [];
            this.filters.lift_no = null;
            if (val && val.id) {
                this.getEquipment();
            }
        },
        async getEquipment() {
            let params = {
                isCMS: false,
                limit: -1,
                page: 1,
                sortColumn: 'tag_name',
                sortDirection: 'ASC',
                filter: {
                    location_id: this.filters.block.id,
                    is_active: true,
                }
            }
            this.loading.lift_no = true
            await this.$store.dispatch("EquipmentV2Controller/getEquipments", params)
            .then(response => {
                if(response.data.data.items && response.data.data.items.length) {
                    this.options.lift_nos = response.data.data.items.map(item => {
                        if(item.custom_fields && item.custom_fields.length) {
                            const liftNoField = item.custom_fields.find(field => field.attribute && field.attribute.name && (field.attribute.name === 'Lift No' || field.attribute.name === 'Lift Number'));
                            if (liftNoField && liftNoField.value) {
                                return liftNoField.value;
                            }
                        }
                    }).filter((value, index, self) => self.indexOf(value) === index && value); // Remove duplicates and null/undefined
                }
            })
            .catch(() => {})
            .finally(() => {
                this.loading.lift_no = false;
            });
        },
    },
};
</script>
